import React from 'react';
import Icon from '../../../components/AppIcon';
import { Card, CardHeader, CardTitle, CardContent } from '../../../components/ui/Card';
import Button from '../../../components/ui/Button';
import Badge from '../../../components/ui/Badge';

const LeadsPipelineWidget = ({ leadsByStage, onViewAll }) => {
  const getStageColor = (stage) => {
    const colors = {
      'New': 'primary',
      'Contacted': 'secondary',
      'Qualified': 'accent',
      'Proposal': 'warning',
      'Negotiation': 'success',
      'Won': 'success-solid',
      'Lost': 'danger'
    };
    return colors?.[stage] || 'default';
  };

  const getStageIcon = (stage) => {
    const icons = {
      'New': 'UserPlus',
      'Contacted': 'Phone',
      'Qualified': 'CheckCircle',
      'Proposal': 'FileText',
      'Negotiation': 'MessageSquare',
      'Won': 'Trophy',
      'Lost': 'XCircle'
    };
    return icons?.[stage] || 'Circle';
  };

  return (
    <Card shadow="md" className="border border-border">
      <CardHeader>
        <div className="flex items-center justify-between">
          <CardTitle className="flex items-center gap-2">
            <Icon name="TrendingUp" size={20} className="text-primary-500" />
            Leads Pipeline
          </CardTitle>
          <Button
            variant="ghost"
            size="sm"
            onClick={onViewAll}
            iconName="ArrowRight"
            iconPosition="right"
          >
            View All
          </Button>
        </div>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-7 gap-3">
          {leadsByStage?.map((stage) => (
            <div
              key={stage?.stage}
              className="text-center p-4 rounded-lg bg-muted hover:bg-neutral-100 transition-smooth"
            >
              <div className="flex justify-center mb-2">
                <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center">
                  <Icon name={getStageIcon(stage?.stage)} size={20} className="text-primary-600" />
                </div>
              </div>
              <h4 className="text-h2 font-heading font-bold text-foreground mb-1">
                {stage?.count}
              </h4>
              <Badge variant={getStageColor(stage?.stage)} size="sm" className="w-full justify-center">
                {stage?.stage}
              </Badge>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};

export default LeadsPipelineWidget;